/**
 * `APP_CONTEXT_CHANGE` cross-frame notification — port of the postMessage the
 * legacy `ValidateRouteGuard` broadcasts on every validated navigation
 * (`raptor-shell-ui/.../guards/validate-route.guard.ts`). Embedded apps (the MCP
 * chatbot iframe) and module-federated MFEs listen for it to re-sync their
 * app-context to the shell's current page + active client.
 */
export interface AppContextChangeMessage {
  type: 'APP_CONTEXT_CHANGE';
  appName: string;
  clientGuid: string | null;
}

export function postAppContextChange(appName: string, clientGuid: string | null): void {
  const message: AppContextChangeMessage = {
    type: 'APP_CONTEXT_CHANGE',
    appName,
    clientGuid,
  };

  // Post to every embedded iframe (e.g. the chatbot) ...
  document.querySelectorAll('iframe').forEach((iframe) => {
    try {
      iframe.contentWindow?.postMessage(message, '*');
    } catch {
      /* cross-origin frame without access — ignore */
    }
  });

  // ... and to the shell window itself (module-federated MFEs listen here).
  try {
    window.postMessage(message, '*');
  } catch {
    /* ignore */
  }
}
